import { render, staticRenderFns } from "./CustomerListMobile.vue?vue&type=template&id=c69f63e8&scoped=true&"
import script from "./CustomerListMobile.vue?vue&type=script&lang=js&"
export * from "./CustomerListMobile.vue?vue&type=script&lang=js&"
import style0 from "./CustomerListMobile.vue?vue&type=style&index=0&id=c69f63e8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c69f63e8",
  null
  
)

export default component.exports